module.exports = __webpack_public_path__ + "static/media/NodeLogo.909568db.svg";